import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/IFilterTipoAccidenteModel';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterTipoAccidenteModel } from 'src/app/models/tipo-accidente/FilterTipoAccidenteModel';
import { TipoAccidenteModel } from 'src/app/models/tipo-accidente/TipoAccidenteModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoAccidenteService } from 'src/app/services/tipo-accidente/tipo-accidente.service';

@Component({
  templateUrl: './configuracion-tipo-accidente-listar.component.html',
  styleUrls: ['./configuracion-tipo-accidente-listar.component.css']
})
export class ConfiguracionTipoAccidenteListarComponent implements OnInit {
  model!: SearchResultModel<ITipoAccidenteModel[]>;
  filter: IFilterTipoAccidenteModel = new FilterTipoAccidenteModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceTipoAccidente: TipoAccidenteService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<ITipoAccidenteModel[]>(false, new Array<TipoAccidenteModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceTipoAccidente.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceTipoAccidente
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceTipoAccidente
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
